module.exports = __webpack_public_path__ + "img/Group 3684.7021ec32.png";